import client from "@/api";

export const approveSubmission = async (payload) => {
  return await client.post("/approve-submission", payload);
};

export const getMySubmissions = async (userId, openJob = false) => {
  const searchParams = new URLSearchParams();
  searchParams.append("sender", userId);
  searchParams.append("openJob", openJob);

  return await client.post(`/submissionsBySendingUser?${searchParams.toString()}`);
};
